export default "__VITE_ASSET__CQmkKoE2__"